import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { IFocusArea } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/focusArea/models'
import { useMemo } from 'react'

interface IUseFocusAreaValuesParams {
  keyObjective: string
  keyObjectives: IKeyObjective[]
}

export const useFocusAreaValues = ({ keyObjectives, keyObjective }: IUseFocusAreaValuesParams) => {
  return useMemo(() => {
    if (!keyObjective) {
      return []
    }

    const filteredKeyObjectives = keyObjectives.find((el) => el.key === keyObjective)
    if (!filteredKeyObjectives) {
      return []
    }

    if (!filteredKeyObjectives.focusAreas) {
      return []
    }

    return filteredKeyObjectives.focusAreas.map<IFocusArea>((el) => ({
      key: keyObjective,
      area: el,
    }))
  }, [keyObjective, keyObjectives])
}
